import { abyssColors } from '@/theme/colors';
import { Box, styled as muiStyled } from '@mui/material';

export const tabsStyles = {
  width: 'fit-content',
  minHeight: 'fit-content',
  '& .MuiTab-root': {
    width: 'fit-content',
    padding: '1.6rem 0',
    fontSize: '1.4rem',
    fontStyle: 'normal',
    fontWeight: 400,
    minWidth: 'fit-content',
    minHeight: 'fit-content',
    textTransform: 'none',
    lineHeight: '1.6rem',
    flexGrow: 1,
    color: `${abyssColors.primary[400]} !important`,
  },
  '& .MuiTab-root.Mui-selected': {
    color: `${abyssColors.primary[500]} !important`,
    fontWeight: 700,
  },
  '& .MuiTab-textColorPrimary': {
    color: abyssColors.primary[400],
  },
  '& .MuiTabs-indicator': {
    backgroundColor: abyssColors.primary[500],
    height: '0.4rem',
    zIndex: 2,
  },
};

export const FloatingLine = muiStyled(Box)(() => ({
  borderTop: `0.1rem solid ${abyssColors.primary[200]}`,
  width: '100%',
  position: 'relative',
  bottom: '0.3rem',
  zIndex: '1',
  opacity: 0.5,
}));
